import { useEffect, useState } from "react";
import { LayoutDashboard, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const DASH_SECTIONS = [
  ["pending", "Richieste in attesa"], ["today", "Interventi oggi"], ["in_progress", "In corso"],
  ["upcoming", "Confermati in arrivo"], ["absences_pending", "Assenze da valutare"], ["technicians", "Tecnici attivi"],
  ["cantieri_today", "Cantieri di oggi"], ["my_today", "I miei interventi di oggi"], ["ack_late", "Tecnici esterni senza risposta"], ["external", "Interventi a tecnici esterni"],
  ["missing_report", "Cantieri senza rapportino"], ["suspended", "Interventi sospesi"], ["web_pending", "Nuove richieste dal web da confermare"], ["attendance", "Presenti ora"],
];

export function DashboardSettings() {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setHidden(user?.dashboard_hidden || []); }, [open, user]);
  const save = async () => {
    setBusy(true);
    try {
      setUser((await api.put("/me/dashboard", { hidden })).data);
      toast.success("Dashboard aggiornata");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const tog = (k, show) => setHidden((h) => (show ? h.filter((x) => x !== k) : [...h, k]));
  return (
    <>
      <Button variant="outline" className="rounded-full" onClick={() => setOpen(true)} data-testid="dashboard-settings-button"><LayoutDashboard className="h-4 w-4" /> Personalizza</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-md" data-testid="dashboard-settings-dialog">
          <DialogHeader><DialogTitle className="font-display">Cosa vedere nella dashboard</DialogTitle>
            <DialogDescription>Scegli le sezioni da mostrare appena apri l'app. Vale solo per il tuo account.</DialogDescription></DialogHeader>
          <div className="divide-y rounded-xl border">
            {DASH_SECTIONS.map(([k, label]) => (
              <label key={k} className="flex items-center justify-between gap-3 px-3 py-2.5 text-sm" data-testid={`dashboard-pref-${k}`}>
                {label}<Switch checked={!hidden.includes(k)} onCheckedChange={(v) => tog(k, v)} data-testid={`dashboard-pref-${k}-switch`} />
              </label>
            ))}
          </div>
          <DialogFooter className="gap-2">
            <Button variant="ghost" onClick={() => setHidden([])} data-testid="dashboard-pref-show-all">Mostra tutto</Button>
            <Button onClick={save} disabled={busy} className="rounded-full" data-testid="dashboard-pref-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Salva</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
